import { configureTableColumns } from 'utils/table-helpers';
import { FETCH_ALL_PARAMS } from 'constants/query';
import { useMemo } from 'react';
import { useGetTerminalsQuery } from 'features/terminal/services';
import { mapToSelectOptions } from 'utils/filter-select-helpers';
import { useGetCitiesQuery } from 'features/city/service';
import { useRole } from 'hooks/useRole';
import { PlacesColumns, usePlaceTableColumns } from '../constants/table-setting';
import useTable from 'hooks/useTable';

const useController = () => {
    const { data: terminals } = useGetTerminalsQuery(FETCH_ALL_PARAMS);
    const { data: cities } = useGetCitiesQuery(FETCH_ALL_PARAMS);
    const { isAdmin } = useRole();

    const filterSelectOptions = useMemo(() => {
        if (!terminals || !cities) return;

        return {
            terminalName: mapToSelectOptions(terminals.content),
            cityName: mapToSelectOptions(cities.content),
        };
    }, [terminals, cities]);

    const { tableSettings } = useTable<PlacesColumns>({
        columns: configureTableColumns(usePlaceTableColumns(), filterSelectOptions || {}),
        queryIdentifier: 'places',
        renderAddButton: isAdmin,
    });

    return {
        tableSettings,
    };
};

export default useController;
